var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6697 0.818237C15.8924 2.39718 15.2752 3.94403 14.4644 5.03843C13.5954 6.21233 12.0976 7.12179 10.6449 7.0744C10.3814 5.56118 11.0597 4.00364 11.8836 2.95661C12.789 1.80106 14.3421 0.913004 15.6697 0.818237ZM20.0292 23.0473C20.7774 21.8489 21.0569 21.2467 21.6363 19.894C17.4135 18.2157 16.7352 11.9488 20.9157 9.54141C19.6406 7.87228 17.8502 6.90474 16.1588 6.90474C14.9388 6.90474 14.1032 7.23695 13.3439 7.53883C12.7117 7.7902 12.1323 8.02055 11.428 8.02055C10.6658 8.02055 9.99083 7.76794 9.28408 7.50344C8.50748 7.2128 7.69249 6.90779 6.6812 6.90779C4.78162 6.90779 2.76267 8.11837 1.48173 10.188C-0.320332 13.1028 -0.0131958 18.584 2.90678 23.2521C3.95192 24.9227 5.3464 26.8013 7.17029 26.8181C7.92598 26.8252 8.42939 26.5897 8.974 26.3349C9.59803 26.0429 10.2761 25.7256 11.4498 25.7191C12.6321 25.7117 13.2994 26.0329 13.915 26.3292C14.4453 26.5845 14.9373 26.8213 15.6871 26.8135C17.5125 26.7982 18.9856 24.7164 20.0292 23.0473Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.e5ff3b5a6c0f069132553345f1025817.svg";
export { ForwardRef as ReactComponent };